import { CompositeScreenProps } from '@react-navigation/native'
import React from 'react'
import { ScrollView } from 'react-native'

import { Page } from 'partials/Page'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Pressable } from 'widgets/Pressable'
import { Separator } from 'widgets/Separator'
import { Text } from 'widgets/Text'

import { useCurrentUser } from 'hooks/useCurrentUser'

import { defaultNotificationSettings } from 'utils/defaults/notificationSettings'

import { NotificationSettingsRow } from './NotificationSettingsRow'

export const NotificationSettingsPage = ({ navigation }: CompositeScreenProps<any, any>) => {
  const { data: currentUser, isLoading: isUserLoading, update } = useCurrentUser()

  const handlePushSettingChange = (index: number) => {
    if (currentUser && currentUser.notificationSettings) {
      currentUser.notificationSettings[index].push = !currentUser.notificationSettings[index].push
      update.mutate({ data: { notificationSettings: currentUser?.notificationSettings } })
    }
  }

  const handleEmailSettingChange = (index: number) => {
    if (currentUser && currentUser.notificationSettings) {
      currentUser.notificationSettings[index].email = !currentUser.notificationSettings[index].email
      update.mutate({ data: { notificationSettings: currentUser?.notificationSettings } })
    }
  }

  const resetSettingsToDefault = () => {
    if (currentUser) {
      update.mutate({ data: { notificationSettings: defaultNotificationSettings } })
    }
  }

  return (
    <Page
      withBack
      withNav
      backgroundColor='white'
      title='Notification Settings'
      isLoading={isUserLoading}
      navigation={navigation}
    >
      <Separator />
      <ScrollView>
        <Box margin={{ vertical: 'sm', horizontal: 'md' }}>
          {!isUserLoading &&
            currentUser &&
            currentUser.notificationSettings &&
            currentUser.notificationSettings.map((setting, index) => (
              <NotificationSettingsRow
                key={`${setting.identifier}-${setting.push}-${setting.email}`}
                index={index}
                name={setting.displayName}
                push={setting.push}
                email={setting.email}
                onPushChange={() => handlePushSettingChange(index)}
                onEmailChange={() => handleEmailSettingChange(index)}
              />
            ))}
          <Box flexDirection='row' margin={{ vertical: 'md' }}>
            <Box width='100%' align='center'>
              <Pressable onPress={resetSettingsToDefault}>
                <Box flexDirection='row'>
                  <Box margin={{ right: 'sm' }}>
                    <Icon name='reset' color='v2primary' />
                  </Box>
                  <Text color='v2primary'>Reset to default</Text>
                </Box>
              </Pressable>
            </Box>
          </Box>
        </Box>
      </ScrollView>
    </Page>
  )
}
